<template>
	<div class="container-fluid refurbished-builds">
		<overlay
			v-if="selectedBuild"
			:build="selectedBuild.details"
			:checkout-data="checkoutData"
			:games="overlayGames"
			:is-refurbished-build="true"
			:price="selectedBuild.price"
			:resolution="resolution"
			@closed="overlayClosed()"
		/>
		<div class="row bg-white">
			<div class="col-xs-12 container-fluid p-x-lg clearfix">
				<div class="static-pages-title">
					<h1 class="text-upper">Refurbished Builds</h1>
					<div v-if="countryCode == 'US'" class="refurbished-links">
						<a
							href="#"
							class="btn btn-light-gray active"
							@click.prevent
						>
							BUILDS
						</a>
						<a
							target="_blank"
							href="https://www.nzxt.com/refurbished-components"
							class="btn btn-light-gray"
						>
							COMPONENTS
						</a>
					</div>
					<h4 :class="{ open: showDetails }">
						BLD refurbished products are primarily customer-returned machines
						that are fully tested and inspected. These systems are available in
						their pre-configured states at a discounted price. Refurbished
						products are ineligible for return or exchange, however they are
						backed by the same warranty as our new systems.
						<a
							@click.prevent="showDetails = !showDetails"
							href="#"
							class="text-green visible-xs-block"
						>
							{{ showDetails ? "[...less]" : "[...more]" }}
						</a>
					</h4>
				</div>
				<div class="select-a-game">
					<div class="select-a-game__header">
						<div @click="toggleGamesDropdown()" class="select-a-game__title">
							<p>Select a game (up to 3)</p>
							<i
								class="fa"
								:class="{
									'fa-chevron-up': showGames,
									'fa-chevron-down': !showGames
								}"
							/>
						</div>
						<div v-if="selectedGames.length > 0" class="selected-games">
							<div
								v-for="game in filters.games"
								:key="game.id"
								class="selected-game"
							>
								<span>{{ game.name }}</span>
								<div
									class="remove-selected-game"
									@click="removeGameSelection(game)"
								>
									<img src="/images/icons/x.svg" >
								</div>
							</div>
						</div>
					</div>
					<div class="select-a-game__games-list" :class="{ open: showGames }">
						<div class="select-a-game__games-list-container">
							<div
								v-for="game in games"
								:key="`game-${game.id}`"
								class="select-a-game__game"
								:class="{
									'game-is-selected': selectedGames.some(
										item => item.id == game.id
									),
									'too-many':
										selectedGames.findIndex(item => item.id == game.id) > 2
								}"
								@click="toggleGameSelection(game)"
							>
								<img
									:src="game.image_url"
									data-html="true"
									data-toggle="tooltip"
									data-placement="bottom"
									:data-original-title="game.name"
									:title="game.name"
								>
							</div>
							<div v-if="!games.length" class="rf-loading-games">
								Loading games
							</div>
						</div>
						<div class="select-a-game__resolution-and-apply">
							<div class="select-a-game__resolution-switch">
								<general-switch
									class="switch"
									v-model="resolution"
									first-option="1080"
									second-option="1440"
									text-color="#4f4f4f"
								/>
							</div>
							<div class="select-a-game__apply">
								<button
									class="btn"
									:class="{
										'btn-green': selectedGames.length <= 3,
										'btn-danger': selectedGames.length > 3
									}"
									:disabled="!selectedGames.length || selectedGames.length > 3"
									@click="applyGamesFilter()"
								>
									<template v-if="selectedGames.length <= 3">
										Apply
									</template>
									<template v-else>
										<span>Oops, {{ selectedGames.length - 3 }} too many</span>
									</template>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="pick-your-price">
					<div class="pick-your-price__title">PICK YOUR PRICE:</div>
					<div class="pick-your-price__buttons-container">
						<button
							class="btn btn-light-gray"
							:class="{ active: filters.price == 0 }"
							@click="selectPrice(0)"
						>
							ANY PRICE
						</button>
						<button
							class="btn btn-light-gray"
							:class="{ active: filters.price == 1000 }"
							@click="selectPrice(1000)"
						>
							$1000+
						</button>
						<button
							class="btn btn-light-gray"
							:class="{ active: filters.price == 1500 }"
							@click="selectPrice(1500)"
						>
							$1500+
						</button>
						<button
							class="btn btn-light-gray last"
							:class="{ active: filters.price == 2000 }"
							@click="selectPrice(2000)"
						>
							$2000+
						</button>
					</div>
				</div>
				<div class="select-platform">
					<div class="select-platforme__title">SELECT YOUR CPU PLATFORM:</div>
					<div class="select-platform__buttons-container">
						<button
							class="btn btn-light-gray first"
							:class="{ active: filters.cpu == 'all' }"
							@click="selectCpu('all')"
						>
							ALL
						</button>
						<button
							class="btn btn-light-gray"
							:class="{ active: filters.cpu == 'intel' }"
							@click="selectCpu('intel')"
						>
							INTEL
						</button>
						<button
							class="btn btn-light-gray"
							:class="{ active: filters.cpu == 'amd' }"
							@click="selectCpu('amd')"
						>
							AMD
						</button>
					</div>
				</div>
				<div class="non-found-container">
					<div
						v-if="showingRecommended && builds.data.length"
						class="non-found"
					>
						<h2>
							There aren’t any builds with your criteria. Sorry about that.
						</h2>
						<span>
							Please look below to see other builds that might interest you.
						</span>
					</div>
				</div>
				<div class="builds-list">
					<div
						v-for="build in builds.data"
						:key="`build-${build.id}`"
						class="build"
					>
						<div class="row">
							<div class="col-xs-12 build__image">
								<img :src="build.cover_image" class="img-responsive" alt="" >
							</div>
							<div class="col-xs-12 col-md-6 build-specs">
								<div class="build__specs-list">
									<div class="build__spec">
										<div class="build__spec__label">Case:</div>
										<div class="build__spec_title">
											{{ build.details.cases.title }}
											{{
												!+build.details.cases.is_limited
													? "(" + build.details.cases.colors.join("/") + ")"
													: ""
											}}
										</div>
									</div>
									<div class="build__spec">
										<div class="build__spec__label">CPU:</div>
										<div class="build__spec_title">
											{{ build.details.cpus.title }}
										</div>
									</div>
									<div class="build__spec">
										<div class="build__spec__label">GPU:</div>
										<div class="build__spec_title">
											{{ build.details.gpus.title }}
											<template v-if="build.details.gpus.quantity > 1">
												x {{ build.details.gpus.quantity }}
											</template>
										</div>
									</div>
									<div class="build__spec">
										<div class="build__spec__label">RAM:</div>
										<div class="build__spec_title">
											{{ build.details.ram.name }}
											<small>(max speed)</small>
											<span
												v-html="
													computeRamCapacity(
														build.details.ram.capacity,
														build.details.ram.slots,
														build.details.ram.quantity
													)
												"
											/>
										</div>
									</div>
									<div v-if="build.details.storage.SSD" class="build__spec">
										<div class="build__spec__label">SSD:</div>
										<div class="build__spec_title">
											<span
												v-for="ssd in build.details.storage.SSD"
												:key="`ssd-${ssd.id}`"
											>
												{{ ssd.title }} {{ ssd.capacity }}
												<template v-if="ssd.quantity > 1">
													x {{ ssd.quantity }}
												</template>
												<br >
											</span>
										</div>
									</div>
									<div v-if="build.details.storage.HDD" class="build__spec">
										<div class="build__spec__label">HDD:</div>
										<div class="build__spec_title">
											<span
												v-for="hdd in build.details.storage.HDD"
												:key="`hdd-${hdd.id}`"
											>
												{{ hdd.title }} {{ hdd.capacity }}
												<template v-if="hdd.quantity > 1">
													x {{ hdd.quantity }}
												</template>
												<br >
											</span>
										</div>
									</div>
									<template v-if="buildsDetails.includes(build.id)">
										<div class="build__spec">
											<div class="build__spec__label">PSU:</div>
											<div class="build__spec_title">
												{{ build.details.psus.title }}
											</div>
										</div>
										<div class="build__spec">
											<div class="build__spec__label">Mobo:</div>
											<div class="build__spec_title">
												{{ build.details.motherboards.title }}
											</div>
										</div>
										<div class="build__spec">
											<div class="build__spec__label">Cool:</div>
											<div class="build__spec_title">
												{{ build.details.coolers.title }}
											</div>
										</div>
										<div v-if="build.details.rgbs" class="build__spec">
											<div class="build__spec__label">RGB:</div>
											<div class="build__spec_title">
												<span
													v-for="rgb in build.details.rgbs"
													:key="`rgb-${rgb.id}`"
												>
													{{ rgb.title }}
													<template v-if="rgb.quantity > 1">
														x {{ rgb.quantity }}
													</template>
													<br >
												</span>
											</div>
										</div>
										<div v-if="build.details.extras" class="build__spec">
											<div class="build__spec__label">ACC.:</div>
											<div class="build__spec_title">
												<span
													v-for="extra in build.details.extras"
													:key="`extra-${extra.id}`"
												>
													{{ extra.title }}
													<template
														v-if="
															extra.title.toLowerCase().includes('cablemod')
														"
													>
														({{ extra.colors.join("/") }})
													</template>
													<br >
												</span>
											</div>
										</div>
										<div v-if="build.details.bundles" class="build__spec">
											<div class="build__spec__label">BDL.:</div>
											<div class="build__spec_title">
												<span
													v-for="bundle in build.details.bundles"
													:key="`bundle-${bundle.id}`"
												>
													{{ bundle.title }}
													<template v-if="bundle.quantity > 1">
														x {{ bundle.quantity }}
													</template>
													<br >
												</span>
											</div>
										</div>
									</template>
									<a
										href="#"
										class="build__see-more text-green"
										@click.prevent="toggleBuildDetail(build)"
									>
										[{{
											buildsDetails.includes(build.id) ? "...less" : "...more"
										}}]
									</a>
								</div>
								<div
									v-if="filters.games.length"
									class="selected-games uppercase"
								>
									<div
										v-for="game in filters.games"
										:key="game.id"
										class="selected-game"
									>
										<span>{{ game.name }}: {{ showGameFps(build, game) }}</span>
									</div>
								</div>
							</div>
							<div class="col-xs-12 col-md-6">
								<div class="build__prices-and-checkout">
									<div class="build__list-price">
										<span>List Price:</span>
										<div class="line-through">${{ build.original_price }}</div>
									</div>
									<div class="build__discounted-price">
										<span>Discounted Price:</span>
										<div class="build__discounted-price__total">
											<promo-sales-timed>
												<template v-slot:originalContent>
													${{ build.price }}
												</template>
												<template>
													${{ promoDiscount(build.price) }}
												</template>
											</promo-sales-timed>
										</div>
									</div>
									<promo-sales-timed>
										<template v-slot:originalContent>
											<div class="build__you-save">
												<span>You Save:</span>
												<div class="build__save-percentage">
													{{ priceDifference(build) }}
												</div>
											</div>
										</template>
										<template slot-scope="{ phasesInfo: { currentPhase } }">
											<div class="build__you-save">
												<holiday-saving-msg
													v-if="casePromo(build.details.cases)"
													:phase="currentPhase"
													text="refurbishedBuildsCase"
												/>
												<holiday-saving-msg
													v-else
													:phase="currentPhase"
													text="refurbishedBuildsNonCase"
												/>
											</div>
										</template>
									</promo-sales-timed>
									<button class="build__add-to-cart btn btn-green" @click="selectBuild(build)">Overview</button>
								</div>
							</div>
						</div>
					</div>
					<div v-if="!builds.data.length && !fetchingBuilds" class="non-found">
						<h2>There are no refurbished builds available at this time.</h2>
					</div>
					<div v-if="fetchingBuilds" class="rf-loading-builds">
						<p>Loading</p>
					</div>
				</div>
				<div
					v-if="builds.data.length && builds.total_pages > 1"
					class="builds-pagination rev-pagination m-t-md"
				>
					<a disabled class="text-green pag-arrow ">
						<i
							class="fa fa-chevron-left"
							:class="{ builds_pagination__arrow_disabled: page == 1 }"
							@click="changePage(-1)"
							aria-hidden="true"
						/>
					</a>
					<div class="pag-text">
						<p class="first-number">{{ page }}</p>
						<p>of</p>
						<p class="last-number">{{ builds.total_pages }}</p>
					</div>
					<a class="text-green pag-arrow">
						<i
							class="fa fa-chevron-right"
							:class="{
								builds_pagination__arrow_disabled: page == builds.total_pages
							}"
							@click="changePage(1)"
							aria-hidden="true"
						/>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { computeRamCapacity } from "@u/store-helpers";
import { promoDiscount, casePromo } from "@u/helpers";
import GeneralSwitch from "@c/generals/general-switch";
import Overlay from "../overlay.vue";
import PromoSalesTimed from "@/components/promo-sales-timed";
import HolidaySavingMsg from "@c/generals/holiday-saving-msg";

export default {
	name: "RefurbishedBuilds",
	components: {
		Overlay,
		GeneralSwitch,
		PromoSalesTimed,
		HolidaySavingMsg
	},
	data() {
		return {
			builds: {
				data: []
			},
			buildsDetails: [],
			checkoutData: null,
			fetchingBuilds: true,
			filters: {
				cpu: "all",
				games: [],
				price: 0
			},
			initialized: false,
			games: [],
			overlayGames: [],
			page: 1,
			resolution: "1080",
			selectedBuild: null,
			selectedGames: [],
			selectedGamesFps: [],
			showDetails: false,
			showGames: false,
			showingRecommended: false,
			filterPrice: "price>0"
		};
	},
	computed: {
		...mapState({
			countryCode: state => state.User.location.country_code
		}),
		filterQuery() {
			let query = `cpu:${this.filters.cpu},`;

			if (this.filters.cpu == "all") {
				query = "";
			}

			if (this.filters.price == 0) {
				query += "price>0";
			} else if (this.filters.price == 1000) {
				query += "price>1000";
			} else if (this.filters.price == 1500) {
				query += "price>1300";
			} else {
				query += "price>1800";
			}

			return query;
		}
	},
	watch: {
		"filters.games"(current) {
			if (current.length) {
				this.getGamesFps();
			}
		},
		"filters.price"(price) {
			if (price == 0) {
				this.filterPrice = "price>0";
			} else if (price == 1000) {
				this.filterPrice = "price>1000";
			} else if (price == 1500) {
				this.filterPrice = "price>1300";
			} else {
				this.filterPrice = "price>1800";
			}
		},
		filterQuery() {
			this.fetchingBuilds = true;
			this.page = 1;
			this.showingRecommended = false;

			if (this.filters.cpu != "all") {
				this.showRecommended();
			} else {
				this.getAllRefurbishedBuilds();
			}
		},
		page() {
			this.fetchingBuilds = true;
			this.getAllRefurbishedBuilds();
		}
	},
	created() {
		this.getGameList();
		this.getAllRefurbishedBuilds();
	},
	updated() {
		$('[data-toggle="tooltip"]').tooltip();
	},
	methods: {
		computeRamCapacity,
		promoDiscount,
		casePromo,
		applyGamesFilter() {
			const filteredGames = _.clone(this.selectedGames);
			filteredGames.sort((a, b) => {
				return a.name.localeCompare(b.name);
			});
			this.filters.games = filteredGames;
			this.showGames = false;
		},
		changePage(direction) {
			if (!this.fetchingBuilds) {
				this.page = this.page + direction;
				if (this.page < 1) {
					this.page = 1;
				} else if (this.page > this.builds.total_pages) {
					this.page = this.builds.total_pages;
				}
			}
		},
		getGamesFps() {
			let buildCombos = [];

			this.builds.data.forEach(build => {
				buildCombos.push(
					`${build.details.cpus.products_id}-${build.details.gpus.products_id}`
				);
			});

			buildCombos = _.uniq(buildCombos).join(",");

			axios({
				url: `/refurbished-builds-fps?combos=${buildCombos}`
			}).then(response => {
				this.selectedGamesFps = response.data;
			});
		},
		getGameList() {
			axios({
				url: "/games?q=(is_deleted:0,is_disabled:0)&sort=name|ASC"
			}).then(response => {
				this.games = response.data;
			});
		},
		getAllRefurbishedBuilds: _.debounce(function debounce() {
			axios({
				url: `/public-refurbished-builds?q=(${this.filterPrice})&sort=price|ASC&page=${this.page}`
			})
				.then(response => {
					if (response.data.data == 0) {
						this.getAllRefurbishedBuilds();
						this.showingRecommended = true;
					} else {
						this.builds = response.data;
						this.processRefurbishedGames();
					}
				})
				.finally(() => {
					this.fetchingBuilds = false;
				});
		}, 1000),
		showRecommended: _.debounce(function debounce() {
			this.fetchingBuilds = true;
			axios({
				url: `/public-refurbished-builds?q=(${this.filterQuery})&sort=price|ASC&page=${this.page}`
			})
				.then(response => {
					if (response.data.data == 0) {
						this.builds = {};
						this.filterPrice = "price>0";
						this.showingRecommended = true;
						this.getAllRefurbishedBuilds();
					} else {
						this.builds = response.data;
						this.showingRecommended = false;
						this.processRefurbishedGames();
					}
				})
				.finally(() => {
					this.fetchingBuilds = false;
				});
		}, 1000),
		overlayClosed() {
			this.selectedBuild = null;
		},
		priceDifference(build) {
			const amount = build.original_price - build.price;
			const percent = Math.floor((amount / build.original_price) * 100);

			return `$${amount.toFixed(2)} (${percent}%)`;
		},
		processRefurbishedGames() {
			this.getGamesFps();
		},
		removeGameSelection(game) {
			this.selectedGames = this.selectedGames.filter(
				item => item.id != game.id
			);
			this.filters.games = this.filters.games.filter(
				item => item.id != game.id
			);
		},
		selectBuild(build) {
			this.checkoutData = {
				bldNumber: build.id
			};
			this.overlayGames = this.filters.games.map(game => {
				game.fps = this.showGameFps(build, game);

				return game;
			});
			this.selectedBuild = build;
		},
		selectCpu(cpu) {
			this.filters.cpu = cpu;
		},
		selectPrice(price) {
			this.filters.price = price;
		},
		showGameFps(build, game) {
			const buildId = `${build.details.cpus.products_id}-${build.details.gpus.products_id}`;
			let fpsData = this.selectedGamesFps[buildId];
			fpsData =
				fpsData && fpsData[game.id]
					? fpsData[game.id][`fps_${this.resolution}`]
					: 0;
			fpsData = fpsData ? `${fpsData}FPS` : "Pending";

			return fpsData;
		},
		toggleBuildDetail(build) {
			const buildIndex = this.buildsDetails.findIndex(item => item == build.id);

			if (buildIndex == -1) {
				this.buildsDetails.push(build.id);
			} else {
				this.buildsDetails.splice(buildIndex, 1);
			}
		},
		toggleGameSelection(game) {
			const gameIndex = this.selectedGames.findIndex(
				item => item.id == game.id
			);

			if (gameIndex == -1) {
				this.selectedGames.push(game);
			} else {
				this.selectedGames.splice(gameIndex, 1);
			}
		},
		toggleGamesDropdown() {
			this.showGames = !this.showGames;

			if (this.showGames) {
				this.$scrollTo(".select-a-game", 250, {
					offset: -150
				});
			}
		}
	}
};
</script>

<style>
.select-a-game__resolution-switch .switchery small {
	box-shadow: none;
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.refurbished-builds {
	color: #4a4a4a;

	.refurbished-links {
		margin-bottom: 12px;

		.btn:active,
		.btn.active {
			box-shadow: none;
			color: #fff;
			border-color: $purple;
			background-color: $purple;
			border: 1px solid #979797;
		}

		a {
			padding: 0;
			width: 155px;
			height: 46px;
			text-align: center;
			margin: 0 auto;
			line-height: 3.1;
		}

		a:first-child {
			margin-right: 15px;
			cursor: default;
		}

		a:nth-child(2) {
			color: #4a4a4a;
			&:hover {
				@extend .active;
				color: #e9e9e9;
			}
		}

		@media (max-width: 480px) {
			a {
				margin-top: 12px;
			}
		}
	}

	.btn-light-gray {
		background-color: #e9e9e9;
		border: 1px solid #e9e9e9;
		padding: 12px 0;
	}

	.static-pages-title {
		padding-top: 80px;

		h1 {
			margin-bottom: 10px;
		}

		h4 {
			letter-spacing: 0.56px;
			line-height: 28px;
			font-size: 20px;
			margin-bottom: 30px;
		}
	}

	.select-a-game {
		margin-bottom: 25px;

		.select-a-game__header {
			background-color: #eeeeee;
			font-size: 14px;
			letter-spacing: 1.35px;
			line-height: 16px;
			color: #4a4a4a;
			text-transform: uppercase;
			font-family: "Helvetica", Arial, sans-serif;
			display: flex;
			align-items: center;

			.select-a-game__title {
				display: flex;
				align-items: center;
				cursor: pointer;
				padding: 20px 30px;

				> i {
					margin-left: 5px;
					opacity: 0.7;
					font-size: 8px;
				}

				p {
					margin-bottom: 0;
				}
			}
		}

		.select-a-game__games-list {
			background-color: #eeeeee;
			display: flex;
			justify-content: center;
			opacity: 0;
			transform: scaleY(0);
			transition: all 0.1s, opacity 0.5s;
			transform-origin: 0% 0%;
			max-height: 0;
			flex-direction: column;
			align-items: center;
			animation: animateHeight 0.5s;
			margin-bottom: 30px;

			.select-a-game__games-list-container {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: center;
				max-width: 1280px;
				margin-bottom: 30px;

				.select-a-game__game {
					margin: 20px 25px 0;
					flex-basis: 120px;
					flex-grow: 0;
					flex-shrink: 0;
					cursor: pointer;
					position: relative;

					img {
						width: 100%;
						height: 180px;

						@media screen and (max-width: 769px) {
							height: 120px;
						}

						@media screen and (max-width: 450px) {
							height: 110px;
						}
					}
				}

				.select-a-game__game.game-is-selected {
					outline: 5px solid $purple;
					outline-offset: -5px;
				}

				.select-a-game__game.too-many {
					outline: 5px solid red;
					outline-offset: -5px;
				}

				.select-a-game__game:hover {
					@media screen and (min-width: 1025px) {
						outline: 5px solid $purple;
						outline-offset: -5px;
						z-index: 10;
					}
				}
			}

			&.open {
				max-height: 100%;
				opacity: 1;
				transform: scaleY(1);
			}
		}

		.select-a-game__resolution-and-apply {
			display: flex;
			align-items: center;
			width: 100%;
			justify-content: center;
			flex-wrap: wrap;
			margin-bottom: 30px;

			.select-a-game__resolution-switch {
				justify-self: flex-end;
				position: absolute;
				left: 30px;
				display: flex;
				align-items: center;
			}

			.select-a-game__apply {
				button {
					padding: 12px 75px;
				}

				.btn-danger:hover {
					span {
						display: none;
					}
				}

				.btn-danger:hover::after {
					content: "Try removing a choice or two";
				}
			}
		}
	}

	.selected-games {
		display: flex;
		text-transform: uppercase;

		.selected-game {
			margin-left: 10px;
			display: flex;
			align-items: center;
			background-color: white;
			padding: 5px 13px;

			.remove-selected-game {
				background-color: #d8d8d8;
				min-width: 20px;
				border-radius: 10px;
				min-height: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-left: 10px;
				cursor: pointer;

				img {
					width: 10px;
				}
			}

			.remove-selected-game:hover {
				background-color: #c9c9c9;
				color: #000;
			}
		}

		.selected-game:first-child {
			margin-left: 0;
		}

		.selected-game:last-child {
			margin-right: 10px;
		}
	}

	.pick-your-price,
	.select-platform {
		display: flex;
		align-items: center;
		margin-left: 30px;

		@media screen and (max-width: 580px) {
			margin-left: 15px;
		}

		.pick-your-price__title,
		.select-platforme__title {
			min-width: 280px;
			font-size: 14px;
			letter-spacing: 1.35px;
			line-height: 16px;
			color: #4a4a4a;
			text-transform: uppercase;
			font-family: "Helvetica", Arial, sans-serif;
		}

		.btn-light-gray {
			margin-right: 10px;
			letter-spacing: 1.35px;
			margin-bottom: 10px;
			width: 150px;
		}

		.btn:focus,
		.btn:active:focus,
		.btn.active:focus,
		.btn.focus,
		.btn:active.focus,
		.btn.active.focus {
			outline: 0;
		}

		.btn:active,
		.btn.active {
			box-shadow: none;
			color: #fff;
			border-color: $purple;
			background-color: $purple;
			border: 1px solid #979797;
		}
	}

	.select-platform {
		margin-bottom: 60px;

		@media (max-width: 991px) {
			flex-direction: column;
			align-items: start;
		}
	}

	.builds-list {
		min-height: 155px;
		padding-bottom: 20px;
		position: relative;

		.build {
			background-color: #e9e9e9;
			padding: 30px;
			margin-bottom: 30px;
			border-radius: 4px;

			.row {
				display: flex;
			}

			.build__image {
				width: 163px;
			}

			.build__specs-list {
				display: flex;
				flex-direction: column;

				.build__spec {
					display: flex;
					margin-bottom: 5px;

					.build__spec__label {
						background-color: white;
						width: 70px;
						height: 20px;
						font-family: "Akkurat-Pro", "Helvetica Neue", "Helvetica", Arial,
							sans-serif;
						display: flex;
						align-items: center;
						padding-left: 8px;
						text-transform: uppercase;
						font-size: 14px;
						letter-spacing: 1.35px;
						margin-right: 10px;
						flex-shrink: 0;
					}
				}
			}

			.build__see-more {
				display: contents;
				font-weight: 700;
				letter-spacing: 1.35px;
				margin-bottom: 15px;
			}

			.build__prices-and-checkout {
				font-family: "Akkurat-Pro", "Helvetica Neue", "Helvetica", Arial,
					sans-serif;
				text-align: right;

				.build__list-price {
					display: flex;
					font-size: 14px;
					justify-content: flex-end;
					letter-spacing: 1.35px;
					align-items: center;

					.line-through {
						margin-left: 10px;
						font-size: 18px;
						text-decoration: line-through;
					}
				}

				.build__discounted-price {
					display: flex;
					font-size: 14px;
					justify-content: flex-end;
					letter-spacing: 1.35px;
					align-items: center;

					.build__discounted-price__total {
						color: $purple;
						margin-left: 10px;
						font-size: 30px;
						letter-spacing: 2.9px;
						font-weight: 700;
					}
				}

				.build__you-save {
					display: flex;
					font-size: 14px;
					justify-content: flex-end;
					letter-spacing: 1.35px;
					align-items: center;

					.build__save-percentage {
						font-size: 18px;
						margin-left: 10px;
					}
				}

				.build__add-to-cart {
					margin-top: 10px;
					padding: 12px 45px;
				}
			}
		}
	}

	.builds-pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 100px;

		.builds_pagination__arrow {
			font-size: 24px;
			font-weight: bold;
			color: $purple;
			cursor: pointer;
		}

		.builds_pagination__arrow_disabled {
			opacity: 0.6;
			pointer-events: none;
		}

		.builds_pagination__pagination {
			margin: 0 40px;
			font-size: 18px;
			font-family: "Akkurat-Pro", "Helvetica Neue", "Helvetica", Arial,
				sans-serif;
		}
	}

	@media (max-width: 992px) {
		.builds-list {
			.build {
				.row {
					flex-direction: column;
				}
				.build__image {
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-bottom: 40px;

					img {
						width: 250px;
					}
				}
				.build-specs {
					order: -1;
					margin-bottom: 40px;
					display: flex;
					flex-direction: column;
					align-items: center;

					@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
						align-items: flex-start;
					}
				}
			}
		}

		.select-a-game {
			margin-bottom: 0;

			.select-a-game__header {
				flex-direction: column;

				.selected-games {
					flex-wrap: wrap;
					width: 100%;
					padding: 0 20px 10px 20px;

					.selected-game {
						margin-left: 0;
						margin-bottom: 10px;
						padding: 5px;
						width: 32%;
						margin-right: 10px;

						span {
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}

						.remove-selected-game {
							margin-left: auto;
						}
					}

					.selected-game:last-child {
						margin-right: 0;
					}
				}
			}
		}

		.pick-your-price,
		.select-platform {
			.pick-your-price__title,
			.select-platforme__title {
				margin-bottom: 10px;
			}

			button {
				padding: 12px 0;
			}
		}

		.pick-your-price {
			margin-bottom: 40px;

			@media (max-width: 991px) {
				flex-direction: column;
				align-items: start;
			}
		}
	}

	@media (max-width: 768px) {
		.container-fluid {
			padding-right: 0;
			padding-left: 0;
		}

		.static-pages-title {
			padding-top: 60px;
			padding-left: 15px;
			padding-right: 15px;
			h1 {
				font-size: 30px;
				margin-bottom: 5px;
			}
			h4 {
				max-height: 90px;
				overflow: hidden;
				transition: max-height 0.1s, cubic-bezier(0, 1, 0, 1);
				position: relative;
				padding: 0;
				line-height: 30px;
				a {
					position: absolute;
					padding: 0 2px;
					background-color: white;
					right: 0;
					bottom: 0;
				}
			}
			h4.open {
				max-height: 9999px;
				transition: max-height 1s ease-in-out;
				overflow: visible;
				a {
					bottom: -15px;
					line-height: 22px;
				}
			}
		}

		.select-a-game {
			margin-bottom: 0;

			.select-a-game__header {
				.selected-games {
					.selected-game {
						width: 100%;
						margin-right: 0;
					}
				}
			}

			.select-a-game__games-list {
				.select-a-game__games-list-container {
					justify-content: center;

					.select-a-game__game {
						margin: 6px 13px;
						flex-basis: 80px;
					}
				}

				.select-a-game__resolution-and-apply {
					flex-direction: column;

					.select-a-game__resolution-switch {
						position: relative;
						left: 0;
						margin-bottom: 30px;
					}
				}

				.select-a-game__apply {
					button.btn-danger {
						padding: 12px 20px;
					}
				}
			}
		}

		.pick-your-price,
		.select-platform {
			button {
				padding: 12px 16px;
			}
		}

		.builds-list {
			.build {
				border-radius: 0;
			}
			.selected-games {
				.selected-game {
					padding: 5px 3px;
				}
			}
			.build__prices-and-checkout {
				margin-bottom: 40px;

				@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
					display: flex;
					flex-direction: column;
					align-items: flex-start;
				}

				.build__add-to-cart {
					width: 100%;
				}
			}
		}
	}

	@media (max-width: 576px) {
		.select-a-game {
			.select-a-game__games-list {
				.select-a-game__games-list-container {
					max-height: 380px;
					overflow-x: scroll;

					.select-a-game__game {
						flex-basis: 80px;
					}
				}
			}
		}
	}

	.rf-loading-games,
	.rf-loading-builds p {
		background-image: url("/assets/spinner-black.svg");
		background-position: -15px center;
		background-repeat: no-repeat;
		background-size: 76px;
		color: black;
		display: flex;
		font-size: 24px;
		letter-spacing: 2px;
		line-height: 40px;
		padding-left: 54px;
		text-transform: uppercase;
	}

	@media (max-width: 576px) {
		.rf-loading-games {
			background-position: -8px center;
			background-size: 66px;
			font-size: 18px;
		}
	}

	.rf-loading-builds {
		align-items: flex-start;
		background-color: rgba(255, 255, 255, 0.8);
		bottom: 0;
		display: flex;
		left: 0;
		justify-content: center;
		padding-top: 50px;
		position: absolute;
		right: 0;
		top: 0;
	}

	.rf-loading-games::after,
	.rf-loading-builds p::after {
		animation: loadingdots 1s infinite ease-in-out;
		content: "";
		width: 27px;
	}

	.non-found {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: #8d29a0;
		height: 160px;
		width: 100%;
		border: 1px solid #8d29a0;
		margin-bottom: 36px;

		h2 {
			font-size: 24px;
			margin: 0;
		}

		span {
			font-size: 16px;
			display: block;
		}
	}

	@media (max-width: 768px) {
		.non-found-container {
			margin: 0 10px;
		}

		.non-found {
			text-align: center;
			padding: 0 15px;
			h2 {
				font-size: 20px;
			}

			span {
				font-size: 14px;
			}
		}
	}
}

.switch span {
	display: none !important;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
	.btn.btn-light-gray {
		margin-top: 10px;
	}
}

.refurbished-builds::v-deep {
	.holiday-savings-msg {
		p {
			text-align: right;
			color: #4a4a4a;
		}

		.highlight {
			color: $orchid !important;
		}
	}
}
</style>

<style lang="scss">
@import "~@s/_asset-mixers.scss";
</style>
